import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
} from '@angular/core';
import { SharedModule } from '../../shared.module';

@Component({
  selector: 'app-action-menu',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './action-menu.component.html',
  styleUrl: './action-menu.component.scss',
})
export class ActionMenuComponent implements OnDestroy {
  @Input() isOpen: boolean = false;
  @Input() topPosition: string = '10px';
  @Input() rightPosition: string = '10px';
  @Output() open: EventEmitter<void> = new EventEmitter();
  @Output() outsideClick: EventEmitter<void> = new EventEmitter();
  @Output() edit: EventEmitter<void> = new EventEmitter();
  @Output() delete: EventEmitter<void> = new EventEmitter();

  handleOutSideClick() {
    this.outsideClick?.emit?.();
  }
  openMenu() {
    this.open.emit();
  }

  handleEdit() {
    this.handleOutSideClick();
    this.edit.emit();
  }

  handleDelete() {
    this.handleOutSideClick();
    this.delete.emit();
  }
  ngOnDestroy(): void {
    this.outsideClick?.unsubscribe();
  }
}
